/*eslint-disable no-var */
/*eslint-disable no-unused-vars */
/*eslint-disable prefer-const */
import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
//import './index.scss';
import { CoverageFilter } from './coverage-filter';
import CoverageDetails from './coverage-details';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { axiosInstance } from '../../../../api/axios';
import {
  CoverageDetailedSummary,
  getFamilyListForAdmin,
  getNetworkByMasterId,
  identifyDefaultNetwork,
  getIndplanMax,
  getExceptionTier,
  getBenefitYearProps,
} from '../../../../Member/utils/Coverage';
import { insertSpaces } from '../../../utils/strings';
import {
  findoutSelectiveRangeBetweenYears,
  findOutDefaultRangeBasedOnHistory,
  makeDatesArrayAsPerNeed,
  findEffectiveDateInPlanYear,
} from '../../../utils/dates';
import base64url from 'base64url';
import { useDispatch, useSelector } from 'react-redux';
import { setNetworkList } from 'src/redux/member/memberSlice';
import MasterPermissions from '../../../api/MasterPermissions';
import moment from 'moment';

const Coverage = (props) => {
  const dispatch = useDispatch();
  const pageInfo = useRef(null);
  const { MemberStatePreserve, networkListWithMasterId } = useSelector(
    ({ memberSummary }) => memberSummary,
  );
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { Value_Network_For_Coverage_Admin } = useSelector(
    (state) => state.app.appConfigs.Network_Setting,
  );
  const FEATURES = Features_Setting;
  const { coverageSummary, accumulatorSummary } = MemberStatePreserve;
  const [enableQueryParams, setEnableQueryParams] = useState(true);

  const { userOID, memberType, employeeInfo, dependentsInfo, defaultData } =
    props;

  const [accumsFinalUrl, setAccumsFinalUrl] = useState('');

  const coverageForInfo = getFamilyListForAdmin(
    employeeInfo,
    dependentsInfo,
    memberType,
    userOID,
  );
  //Formatted Coverage Details
  const [detailedCoverageSummary, setDetailedCoverageSummary] = useState([]);
  //This is for plan details and coverage history
  const [planDetails, setPlanDetails] = useState([]);
  const [coverageData, setCoverageData] = useState([]);

  //This is for List Coverage Users and Active Coverage user
  const [coverageFor, setCoverageFor] = useState(coverageForInfo);
  const [activeCoverage, setActiveCoverage] = useState(coverageForInfo[0]);
  //This is for list of coverage types and active coverage type
  const [coverageTypes, setCoverageTypes] = useState([]);
  const [activeCoverageType, setActiveCoverageType] = useState('');
  const [networkPlandetails, setNetworkPlandetails] = useState();
  //This is for active user OID and Type
  const [activeOID, setActiveOID] = useState(userOID);
  const [activeMemType, setActiveMemType] = useState(memberType);
  //This is for active product detsils
  const [activeCoverageDetails, setactiveCoverageDetails] = useState();
  const [dataFetching, setDataFetching] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isFirstTimeIndex, setIsFirstTimeIndex] = useState(true);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const currentSliceDate = moment().format('YYYY-MM-DD');
  let defaultFromDate = currentSliceDate;
  let defaultToDate = currentSliceDate;

  if (defaultData && defaultData.dateRange) {
    const tempsliceDate =
      defaultData.dateRange.PlanYearDescription.split(' - ');
    defaultFromDate = tempsliceDate[0];
    defaultToDate = tempsliceDate[1];
  }

  const [selectBenefitYear, setSelectBenefitYear] = useState(null);

  const [selectNetwork, setSelectNetwork] = useState({});
  const [networkOptions, setNetworkOptions] = useState([]);
  const [displayResetCoverageType, setDisplayResetCoverageType] =
    useState(false);
  const [currentActiveFilter, setCurrentActiveFilter] = useState();
  const [benefitYearOptions, setBenefitYearOptions] = useState({
    options: [],
    selectedBenefitYear: {},
  });
  const [startEndDate, setStartEndDate] = useState();

  const [yearORNetworkFilter, setYearORNetworkFilter] = useState('');
  let networkProps = {};

  const fetchCoverageSummary = async (
    oid,
    memType,
    coverageType,
    byPassMemberCoveragePlan = false,
  ) => {
    const network = selectNetwork.value;
    let currentActiveCoverageType = coverageType;
    if (selectBenefitYear) {
      let selectedSliceORYear = selectBenefitYear;
      console.log(selectedSliceORYear);
      console.log('MEMBER coverageType', selectBenefitYear);
      console.log('MEMBER coverageType', defaultData);
      setIsNotFound(false);
      setIsAPIFailed(false);
      try {
        let memberExtCoveragedata = [];
        let effectiveDate = null;
        let firstItemSelected = [];
        let search,
          params,
          selectedIndexParams = 0,
          coverageTypeParams = '';
        search = window.location.search;
        params = new URLSearchParams(search);
        coverageTypeParams = params.get('coverageType');
        selectedIndexParams = params.get('selectedIndex');
        console.log('coverageTypeParams', coverageTypeParams);
        if (!byPassMemberCoveragePlan) {
          let oidPayload =
            selectedIndexParams && enableQueryParams
              ? selectedIndexParams <= 1
                ? coverageFor[1].value
                : coverageFor[selectedIndexParams].value
              : oid;

          let memTypePayload =
            selectedIndexParams && enableQueryParams
              ? selectedIndexParams <= 1
                ? 'Employee'
                : 'Dependent'
              : activeMemType;

          if (typeof selectBenefitYear.value === 'string') {
            const selectItemFormList = findoutSelectiveRangeBetweenYears(
              defaultData.allPlanYear,
              selectBenefitYear,
            );
            var yearValue = {
              startDate: selectItemFormList.fromDate,
              endDate: selectItemFormList.toDate,
            };
          }
          setStartEndDate(yearValue);
          const responseExtCoverage = await axiosInstance.get(
            APIEndpoints.getMemberCoveragePlan() +
              memTypePayload +
              '/oid/' +
              oidPayload +
              '/planstartdate/' +
              yearValue.startDate +
              '/planenddate/' +
              yearValue.endDate,
          );
          const memberExtCoverageSummary =
            responseExtCoverage?.data.Response.EligibilityCoverage;
          const memberExtCoveragePlanDetails =
            responseExtCoverage?.data.Response.EligibilityCoverage[0];
          memberExtCoveragedata =
            responseExtCoverage?.data.Response.EligibilityCoverage[0]
              .MemberCoverage;
          setPlanDetails(memberExtCoveragePlanDetails);
          setCoverageData(memberExtCoverageSummary);
          let coverageTypeParamsDetails = [];
          if (coverageTypeParams && enableQueryParams) {
            coverageTypeParamsDetails = memberExtCoveragedata.filter(
              (item) => item.Product === coverageTypeParams,
            );
          }
          if (coverageType !== undefined) {
            if (
              coverageType === 'Medical' ||
              coverageType === 'Dental' ||
              coverageType === 'Prescription' ||
              coverageType === 'Vision'
            ) {
              let coverageTypeIndex = memberExtCoveragedata.findIndex(
                (covData) => covData.Product === coverageType,
              );
              if (coverageTypeIndex !== -1) {
                firstItemSelected = memberExtCoveragedata[coverageTypeIndex];
              } else {
                setDisplayResetCoverageType(true);
                firstItemSelected = memberExtCoveragedata[0];
              }
            } else {
              const activeCoverageData = memberExtCoveragedata.filter(
                (details) => insertSpaces(details.Product) === coverageType,
              );
              if (activeCoverageData.length > 0) {
                setDataFetching(false);
                setactiveCoverageDetails(activeCoverageData[0]);
              } else {
                setDataFetching(false);
                setDisplayResetCoverageType(true);
                resetYearAndCoverageTypeForNOData(
                  coverageTypes[0],
                  benefitYearProps.options[0],
                  true,
                );
              }
            }
          } else {
            firstItemSelected =
              coverageTypeParams && enableQueryParams
                ? coverageTypeParamsDetails[0]
                : memberExtCoveragedata[0];
            currentActiveCoverageType = firstItemSelected.Product;
          }
          effectiveDate = memberExtCoveragePlanDetails.EffectiveDate;
        } else {
          console.log('ELSE planDetails', planDetails);
          effectiveDate = planDetails.EffectiveDate;
          memberExtCoveragedata = planDetails.MemberCoverage;
          firstItemSelected = detailedCoverageSummary.filter(
            (details) => insertSpaces(details.Product) === coverageType,
          )[0];
          console.log('ELSE firstItemSelected', firstItemSelected);
        }

        let networkCall = [];
        //Network code start here
        //const memberExtCoveragedata = CoverageSummaryData[ 0 ].MemberCoverage.filter( item => item?.Product==='Medical'||item?.Product==='Dental'||item?.Product==='Prescription'||item?.Product==='Vision' );
        if (networkListWithMasterId && networkListWithMasterId.length > 0) {
          networkCall = memberExtCoveragedata.filter(
            (o1) =>
              !networkListWithMasterId.some(
                (o2) => o1?.MasterId === o2.masterId,
              ),
          );
        } else {
          networkCall = memberExtCoveragedata;
        }
        let networkByMasterList = [];
        let networkByMasterListClubed = [];
        if (networkCall && networkCall.length > 0) {
          networkCall = networkCall.filter((f) => f?.MasterId > 0);
          //commenting start
          //let networkItem;
          //networkItem = await axiosInstance.get(
          //APIEndpoints.getMemberCoverageNetwork() +
          //'MasterID/' +
          //networkCall[0]?.MasterId +
          //`/product/${networkCall[0]?.Product}/benefitplan/${btoa(
          //networkCall[0]?.BenefitPlan,
          //)}`,
          //);
          //commenting end
          //networkItem = await axiosInstance.get( APIEndpoints.getMemberCoverageNetwork()+'MasterID/');
          const promises = networkCall.map(async (item) => {
            let networkItem;
            if (
              item?.MasterId > 0 &&
              (item?.Product === 'Medical' ||
                item?.Product === 'Dental' ||
                item?.Product === 'Prescription' ||
                item?.Product === 'Vision')
            ) {
              //networkItem = await axiosInstance.get( APIEndpoints.getMemberCoverageNetwork()+'MasterID/'+item?.MasterId );
              networkItem = await axiosInstance.get(
                APIEndpoints.getMemberCoverageNetwork() +
                  'MasterID/' +
                  item?.MasterId +
                  `/product/${item?.Product}/benefitplan/${btoa(
                    item?.BenefitPlan,
                  )}`,
              );
            }
            return networkItem;
          });

          try {
            const results = await Promise.all(
              promises.map((p) => p.catch((e) => e)),
            );
            const validResults = results.filter(
              (result) => !(result instanceof Error),
            );
            console.log(validResults);
            networkByMasterList = getNetworkByMasterId(validResults);
            networkByMasterListClubed = networkByMasterList.concat(
              networkListWithMasterId?.length > 0
                ? networkListWithMasterId
                : [],
            );
            dispatch(setNetworkList(networkByMasterListClubed));
          } catch (error) {
            console.log(error);
            console.log('Network API fails');
          }
        }
        const lastestNetworkList =
          networkByMasterListClubed && networkByMasterListClubed.length > 0
            ? networkByMasterListClubed
            : networkListWithMasterId;
        let defaultNetwork = {
          selected: { label: 'Default', value: 0 },
        };
        if (Value_Network_For_Coverage_Admin === 'tier') {
          defaultNetwork = identifyDefaultNetwork(
            firstItemSelected,
            lastestNetworkList,
            Coverage_Network,
            true,
          );
        } else {
          defaultNetwork = identifyDefaultNetwork(
            firstItemSelected,
            lastestNetworkList,
            Coverage_Network,
          );
        }
        setSelectNetwork(defaultNetwork.selected);
        setNetworkOptions(defaultNetwork.networkProps);
        networkProps = {
          options: defaultNetwork.networkProps,
          selectedNetwork: defaultNetwork.selected,
        };

        const indplanMax = getIndplanMax(firstItemSelected);
        //let exceptionTier = 'N';
        //if ( defaultNetwork.selected.value !== 0 ) {
        //exceptionTier = getExceptionTier( lastestNetworkList[ defaultNetwork.selected.value ], );
        //}

        if (
          firstItemSelected?.Product !== 'ShortTermDisability' &&
          firstItemSelected?.Product !== 'LongTermDisability'
        ) {
          const { yearName, yearStartDate } =
            getYearAndStartDate(selectedSliceORYear);
          const queryString = `/masterid/${
            firstItemSelected?.MasterId
          }/planYear/${yearName}/networkid/${
            defaultNetwork.selected.value
          }/product/${firstItemSelected.Product}/benefitplan/${btoa(
            firstItemSelected.BenefitPlan,
          )}/effectivedate/${effectiveDate}/indplanmax/${indplanMax}/planyearstartdate/${yearStartDate}`;

          setAccumsFinalUrl(
            APIEndpoints.getMemberCoverageAccumsResource() +
              memType +
              '/oid/' +
              oid +
              queryString,
          );

          const responseAccumulator = await axiosInstance.get(
            APIEndpoints.getMemberCoverageAccumsResource() +
              memType +
              '/oid/' +
              oid +
              queryString,
          );
          const memberAccumSummaryData = responseAccumulator.data;
          const detailedSummaryData = CoverageDetailedSummary(
            memberExtCoveragedata,
            memberAccumSummaryData.Response,
          );
          setNetworkPlandetails(memberAccumSummaryData.Response.PlanDetails);
          const activeSummaryData = detailedSummaryData.filter(
            (eachRecord) => eachRecord.Product !== 'Flex',
          );

          setDetailedCoverageSummary(activeSummaryData);
          if (!byPassMemberCoveragePlan) {
            setCoverageTypeInfo(activeSummaryData, firstItemSelected.Product);
          }
          //setactiveCoverageDetails( activeSummaryData[ 0 ] );
          const finalData = activeSummaryData.filter(
            (details) => details.Product === firstItemSelected.Product,
          )[0];

          //remove dropdown options based on FirstEffectiveDate
          removeOptionsBasedOnFirstEffectiveDate(finalData.FirstEffectiveDate);
          setactiveCoverageDetails(finalData);
          getSelectedIndexes(activeSummaryData);

          setDataFetching(false);
        }
        setIsNotFound(false);
        setIsAPIFailed(false);
      } catch (error) {
        console.log(error);

        //setDataFetching( false );
        if (error.toString().includes('404')) {
          setIsNotFound(true);
          setactiveCoverageDetails([]);
          if (currentActiveFilter !== 'coverageFor') {
            setDisplayResetCoverageType(true);
            setDataFetching(true);
            resetYearAndCoverageTypeForNOData(
              coverageTypes[0],
              benefitYearProps.options[0],
            );
          } else if (selectBenefitYear !== benefitYearProps.options[0]) {
            setDisplayResetCoverageType(true);
            resetYearAndCoverageTypeForNOData(
              coverageType,
              benefitYearProps.options[0],
            );
          }
        } else {
          //setIsAPIFailed(true);
        }
      }
    }
  };

  const getBenifitYearAndOptions = async (coverageType = null) => {
    try {
      const responseHistoryAPI = await axiosInstance.get(
        APIEndpoints.getMemberExtCoverageSummaryResource() +
          activeMemType +
          '/oid/' +
          activeOID,
      );
      if (
        responseHistoryAPI &&
        responseHistoryAPI?.data.Response.EligibilityCoverage.length > 0
      ) {
        const memberHistoryData =
          responseHistoryAPI?.data.Response.EligibilityCoverage;
        const defaultSeleactedYear =
          findOutDefaultRangeBasedOnHistory(memberHistoryData);
        console.log('===============================');
        console.log(defaultSeleactedYear);
        const currentDate = moment().format('YYYY-MM-DD');
        if (
          defaultSeleactedYear &&
          defaultSeleactedYear.MemberCoverage.length > 0
        ) {
          const firstItemSelected = defaultSeleactedYear.MemberCoverage[0];
          let currentActiveCoverageType = '';
          if (coverageType === null) {
            currentActiveCoverageType = firstItemSelected.Product;
          } else {
            currentActiveCoverageType = coverageType;
          }
          let defaultDateFilters = null;
          let memberYearData = null;
          let allPlanYear = null;

          const responseYearAPI = await axiosInstance.get(
            APIEndpoints.getPlanYearPeriod() +
              '/EmployeeType/' +
              activeMemType +
              '/oid/' +
              activeOID +
              '/Product/' +
              currentActiveCoverageType +
              '/Year/' +
              Coverage_Year_Range,
          );
          allPlanYear = responseYearAPI?.data.Response.PlanYearPeriod;
          memberYearData = responseYearAPI?.data.Response.PlanYearPeriod;
          console.log('++++++++++++++++++++++');
          memberYearData = makeDatesArrayAsPerNeed(memberYearData);
          if (
            moment(currentDate).isSameOrAfter(
              defaultSeleactedYear.EffectiveDate,
              'year',
            )
          ) {
            defaultDateFilters = findEffectiveDateInPlanYear(
              memberYearData,
              currentDate,
            );
          }
          console.log(defaultDateFilters);
          if (defaultDateFilters === null || defaultDateFilters === undefined) {
            const tempYear = moment(defaultSeleactedYear.EffectiveDate).year();
            defaultDateFilters = {
              PlanYearDescription: `${tempYear}-01-01 - ${tempYear}-12-31`,
              PlanYear: tempYear,
              fromDate: `${tempYear}-01-01`,
              toDate: `${tempYear}-12-31`,
            };
            memberYearData = [
              {
                PlanYearDescription: `${tempYear}-01-01 - ${tempYear}-12-31`,
                PlanYear: tempYear,
                fromDate: `${tempYear}-01-01`,
                toDate: `${tempYear}-12-31`,
              },
            ];
            allPlanYear.push({
              PlanYearValue: 'null',
              PlanYearDescription: `${tempYear}-01-01 - ${tempYear}-12-31`,
              PlanYear: tempYear,
              fromDate: `${tempYear}-01-01`,
              toDate: `${tempYear}-12-31`,
            });
          }

          allPlanYear = makeDatesArrayAsPerNeed(allPlanYear);
          setupDateFilterOptions({
            coverage: firstItemSelected,
            allPlanYear: allPlanYear,
            dateRange: defaultDateFilters,
            yearOptions: memberYearData,
          });
        }
      }
    } catch (err) {
      console.log(err);

      throw new Error('404 history not found');
    }
  };

  const removeOptionsBasedOnFirstEffectiveDate = (firstEffectiveDate) => {
    let effectiveDate = new Date(firstEffectiveDate);
    setBenefitYearOptions((prevState) => {
      const afterFilterArr = prevState?.options.filter((option) => {
        let sencondDate = new Date(option.value.split(' - ')[1]);
        return effectiveDate < sencondDate;
      });
      return {
        ...prevState,
        options: afterFilterArr,
      };
    });
  };

  const populateDefaultSystemdateSlice = (sliceOptions) => {
    const options = sliceOptions.filter((eachSlice) => {
      if ('' + eachSlice.value.length > 0) {
        const sliceDates = eachSlice.value.split(' - ');
        const fromDate = moment(sliceDates[0]);
        const toDate = moment(sliceDates[1]);
        const currentDate = moment();
        if (fromDate < currentDate && toDate > currentDate) {
          return true;
        }
      } else {
        if (eachSlice.value === moment().year()) {
          return true;
        }
      }
    });
    return options[0];
  };

  const getYearAndStartDate = (selectedBenefitYear) => {
    const returnData = {
      yearName: '',
      yearStartDate: '',
    };
    if ((selectedBenefitYear.value + '').length === 4) {
      returnData.yearName = selectedBenefitYear.value;
      returnData.yearStartDate = 'DED';
    } else {
      const dateInfo = selectedBenefitYear.value.split(' - ')[0];
      returnData.yearStartDate = dateInfo;
      returnData.yearName = dateInfo.split('-')[0];
    }
    return returnData;
  };

  const fetchAccumulatorData = async (oid, memType, netWorkId) => {
    const firstItemSelected = activeCoverageDetails;
    const memberExtCoveragedata = planDetails.MemberCoverage;
    try {
      const indplanMax = getIndplanMax(firstItemSelected);
      let exceptionTier = 'N';
      if (netWorkId !== 0) {
        const masterDataList = networkListWithMasterId.filter(
          (f) => f.masterId === firstItemSelected?.MasterId,
        );
        const newworkData = masterDataList[0].data.filter(
          (f) => f.NetID === netWorkId,
        );
        exceptionTier = getExceptionTier(newworkData);
      }
      const { yearName, yearStartDate } =
        getYearAndStartDate(selectBenefitYear);
      const queryString = `/masterid/${
        firstItemSelected?.MasterId
      }/planYear/${yearName}/networkid/${netWorkId}/product/${
        firstItemSelected.Product
      }/benefitplan/${btoa(
        firstItemSelected.BenefitPlan,
      )}/effectivedate/2022-08-01/indplanmax/${indplanMax}/exceptiontier/${exceptionTier}/planyearstartdate/${yearStartDate}`;

      setAccumsFinalUrl(
        APIEndpoints.getMemberCoverageAccumsResource() +
          memType +
          '/oid/' +
          oid +
          queryString,
      );

      const responseAccumulator = await axiosInstance.get(
        APIEndpoints.getMemberCoverageAccumsResource() +
          memType +
          '/oid/' +
          oid +
          queryString,
      );
      const memberAccumSummaryData = responseAccumulator.data;
      const detailedSummaryData = CoverageDetailedSummary(
        memberExtCoveragedata,
        memberAccumSummaryData.Response,
      );
      const activeSummaryData = detailedSummaryData.filter(
        (eachRecord) => eachRecord.Product !== 'Flex',
      );
      setDetailedCoverageSummary(activeSummaryData);
      //setCoverageTypeInfo( activeSummaryData );
      //setactiveCoverageDetails( activeSummaryData[ 0 ] );
      const finalData = activeSummaryData.filter(
        (details) => details.Product === firstItemSelected.Product,
      )[0];
      setactiveCoverageDetails(finalData);
      //getSelectedIndexes( activeSummaryData );
      setDataFetching(false);
    } catch (error) {
      console.log(error);
      setDataFetching(false);
      if (error.toString().includes('404')) {
        setIsNotFound(true);
        setactiveCoverageDetails([]);
      }
      setIsAPIFailed(true);
    }
  };

  //This method is for handling dashboard selection redirects
  const getSelectedIndexes = (activeSummaryData) => {
    let search,
      params,
      selectedIndex = 0,
      coverageType = '';
    search = window.location.search;
    params = new URLSearchParams(search);
    selectedIndex = params.get('selectedIndex');
    coverageType = params.get('coverageType');
    if (selectedIndex !== null && coverageType !== null && isFirstTimeIndex) {
      setIsFirstTimeIndex(false);
      updateActiveUserInfo(+selectedIndex);
    }
    if (selectedIndex !== null && coverageType !== null && isFirstTime) {
      setIsFirstTime(false);
      setActiveCoverageType(coverageType);
      setActiveCoverage(coverageFor[selectedIndex]);
      const activeCoverageData = activeSummaryData.filter(
        (details) => insertSpaces(details.Product) === coverageType,
      );
      setactiveCoverageDetails(activeCoverageData[0]);
    }
  };
  const updateActiveUserInfo = (activeIndex) => {
    if (activeIndex <= 1) {
      setActiveMemType(memberType);
      setActiveOID(userOID);
    } else {
      setActiveMemType('Dependent');
      setActiveOID(coverageFor[activeIndex].value);
    }
  };

  const { Coverage_Network } = useSelector((state) => state.app.customNetwork);

  const Coverage_Year_Range =
    useSelector(
      (state) => state.app.appConfigs.Common_Setting.Coverage_Year_Range,
    ) || 5;

  const coverageChangeHandler = (e) => {
    setIsAPIFailed(false);
    setEnableQueryParams(false);
    const selectedIndex = coverageFor?.findIndex(
      (coverage) => coverage?.value === e.value,
    );
    setActiveCoverage(coverageFor[selectedIndex]);
    setActiveCoverageType(coverageTypes[0]);
    setactiveCoverageDetails(detailedCoverageSummary[0]);
    updateActiveUserInfo(selectedIndex);
  };

  const coverageTypeChangeHandler = async (
    coverageType,
    applyFilter = true,
  ) => {
    if (
      coverageType === 'Medical' ||
      coverageType === 'Dental' ||
      coverageType === 'Prescription' ||
      coverageType === 'Vision'
    ) {
      await getBenifitYearAndOptions(coverageType);
      setActiveCoverageType(coverageType);
      setCurrentActiveFilter('coverageType');
      setYearORNetworkFilter('coverageType');
      setEnableQueryParams(false);
      setDisplayResetCoverageType(false);
      //if ( applyFilter ) {
      //const activeCoverageData = detailedCoverageSummary.filter(
      //details => insertSpaces( details.Product ) === coverageType,
      //);
      //setactiveCoverageDetails( activeCoverageData[ 0 ] );
      //}
      if (
        coverageType === 'Medical' ||
        coverageType === 'Dental' ||
        coverageType === 'Prescription' ||
        coverageType === 'Vision'
      ) {
        setDataFetching(true);
        setDisplayResetCoverageType(false);
        fetchCoverageSummary(activeOID, activeMemType, coverageType);
      }
    } else {
      setActiveCoverageType(coverageType);
      setCurrentActiveFilter('coverageType');
      setYearORNetworkFilter('coverageType');
      setEnableQueryParams(false);
      setDisplayResetCoverageType(false);
      if (applyFilter) {
        const activeCoverageData = detailedCoverageSummary.filter(
          (details) => insertSpaces(details.Product) === coverageType,
        );
        setactiveCoverageDetails(activeCoverageData[0]);
      }
    }
  };

  const setCoverageTypeInfo = (coverageData, coverageTypeParm) => {
    const coverages = [];
    coverageData.map((eachCoverage, index) => {
      if (eachCoverage.CoverageType === 'Secondary Coverage') {
        coverages.push(
          insertSpaces(eachCoverage.Product + '_' + eachCoverage.CoverageType),
        );
      } else {
        coverages.push(insertSpaces(eachCoverage.Product));
      }
      return;
    });
    setActiveCoverageType(coverageTypeParm);
    setCoverageTypes(coverages);
  };

  const benefitYearChangeHandler = (selectedValue) => {
    if (benefitYearOptions.selectedBenefitYear.value !== selectedValue.value) {
      setSelectBenefitYear(selectedValue);
      setBenefitYearOptions((prevState) => ({
        ...prevState,
        selectedBenefitYear: selectedValue,
      }));
      setCurrentActiveFilter('benefitYear');
      setYearORNetworkFilter(`benefitYear-${selectedValue.value}`);
      setDataFetching(true);
      setDisplayResetCoverageType(false);
    }
    //activeCoverageType !== coverageTypes[0]
    //? setDisplayResetCoverageType(true)
    //: setDisplayResetCoverageType(false);
    //fetchCoverageSummary( activeOID, activeMemType );
  };

  const networkChangeHandler = (selectedValue) => {
    setSelectNetwork(selectedValue);
    setCurrentActiveFilter('network/tier');
    setYearORNetworkFilter(`network/tier-${selectedValue.value}`);
    setDataFetching(true);
    setDisplayResetCoverageType(false);
    fetchAccumulatorData(activeOID, activeMemType, selectedValue.value);
  };

  const resetYearAndCoverageTypeForNOData = (
    coverageType,
    benefitYear,
    resetCoverageType = false,
  ) => {
    setIsNotFound(false);
    if (resetCoverageType) {
      setActiveCoverageType(coverageType);
    }
    setSelectBenefitYear(benefitYear);
  };

  const setupDateFilterOptions = (listDates) => {
    const planYearsData = listDates.allPlanYear;
    let selectedSliceORYear = null;
    const benefitYears = [];
    planYearsData.map((year) => {
      if (year.PlanYearValue === 'DED Year' || year.PlanYearValue === 'null') {
        benefitYears.push({
          label: `${year.PlanYear}`,
          value: `${year.PlanYear}-01-01 - ${year.PlanYear}-12-31`,
        });
      } else {
        benefitYears.push({
          label: year.PlanYearDescription,
          value: year.PlanYearDescription,
        });
      }
    });

    if (selectBenefitYear === '' || selectBenefitYear == undefined) {
      if (benefitYears?.length > 0) {
        setSelectBenefitYear(
          benefitYears.filter(
            (f) => f.value === listDates.dateRange.PlanYearDescription,
          )[0],
        );
        selectedSliceORYear = benefitYears.filter(
          (f) => f.value === listDates.dateRange.PlanYearDescription,
        )[0];
      }
    } else {
      selectedSliceORYear = selectBenefitYear;
    }

    const yearOptions = [];
    for (let i = benefitYears.length - 1; i >= 0; i--) {
      yearOptions.push(benefitYears[i]);
    }
    setBenefitYearOptions({
      options: yearOptions,
      selectedBenefitYear: selectedSliceORYear,
    });
  };

  useEffect(() => {
    setDataFetching(true);
    if (coverageTypes.length > 0 && activeCoverageType !== coverageTypes[0]) {
      fetchCoverageSummary(activeOID, activeMemType, activeCoverageType, false);
    } else {
      if (currentActiveFilter === 'benefitYear') {
        fetchCoverageSummary(
          activeOID,
          activeMemType,
          activeCoverageType,
          false,
        );
      } else {
        fetchCoverageSummary(activeOID, activeMemType);
      }
    }
  }, [activeOID, selectBenefitYear]);

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);
  const CloseResetCoverageTypeMessage = () => {
    setDisplayResetCoverageType(false);
  };

  useEffect(() => {
    if (props.defaultData) {
      setupDateFilterOptions(props.defaultData);
    }
  }, [props.defaultData]);

  const benefitYearProps = getBenefitYearProps(
    Coverage_Year_Range,
    selectBenefitYear,
  );

  networkProps = {
    options: networkOptions,
    selectedNetwork: selectNetwork,
  };

  return (
    <>
      <div className="coverage-info">
        <div className="coverage-filter-container filter-bar-border-top filter-bar-border-bottom mt-2 mb-md-4 mb-xs-3">
          <div className="container-offset">
            {props?.coverageData && (
              <CoverageFilter
                coverageTypes={coverageTypes}
                benefitYearProps={benefitYearOptions}
                benefitYearChangeHandler={benefitYearChangeHandler}
                networkProps={networkProps}
                networkChangeHandler={networkChangeHandler}
                coverageTypeChangeHandler={coverageTypeChangeHandler}
                activeCoverageType={activeCoverageType}
                activeMemType={activeMemType}
                coverageData={coverageData}
              />
            )}
          </div>
        </div>
        <div className="coverage-details-info container-offset">
          {props?.coverageData && (
            <CoverageDetails
              {...activeCoverageDetails}
              CurrentActive={activeCoverage.value}
              dataFetching={dataFetching}
              isAPIFailed={isAPIFailed}
              isNotFound={isNotFound}
              activeCoverageType={activeCoverageType}
              activeOID={activeOID}
              activeMemType={activeMemType}
              planDetails={planDetails}
              coverageData={coverageData}
              membersCovered={props.coverageFor}
              selectedUser={props.selectedUser}
              isFamilySelected={props.isFamilySelected}
              benefitYearProps={benefitYearOptions}
              displayResetCoverageType={displayResetCoverageType}
              coverageTypes={coverageTypes}
              networkProps={networkProps}
              CloseResetCoverageTypeMessage={CloseResetCoverageTypeMessage}
              currentActiveFilter={currentActiveFilter}
              yearORNetworkFilter={yearORNetworkFilter}
              networkPlandetails={networkPlandetails}
              startEndDate={startEndDate}
              accumsFinalUrl={accumsFinalUrl}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Coverage;
